import { useState, useRef, useCallback, useEffect, useMemo } from 'react'
import ctc from 'copy-to-clipboard'

export default function useCopy() {
    const [copied, setCopied] = useState(false)

    const timeoutIdRef = useRef(null)

    const copy = useCallback((value) => {
        clearTimeout(timeoutIdRef.current)

        ctc(value)

        setCopied(true)

        timeoutIdRef.current = setTimeout(() => {
            setCopied(false)
        }, 3000)
    }, [])

    useEffect(() => () => {
        clearTimeout(timeoutIdRef.current)
    }, [])

    return useMemo(() => ({
        copied,
        copy,
    }), [copied, copy])
}
